import React, { useCallback, useContext } from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { getInvoiceType } from "../constants"
import { EventBus } from "../eventbus"
import { FeatureService } from "../services/FeatureService"
import { RechnungsdatenSonstigeView } from "./RechnungsdatenSonstigeView"
import { RechnungstexteView } from "./RechnungstexteView"
import { ConfigContext } from "../contexts/CustomConfigContext"
import { useStoreRechnung } from "../store"

export function RechnungsdatenView() {
    const config = useContext(ConfigContext)
    const { rechnungsdaten, lieferinformation } = useStoreRechnung("rechnungsdaten", "lieferinformation")
    const invoiceTypeOptions = getInvoiceType()
    const { t } = useTranslation()

    const onChange = useCallback<(element: string) => (value: any) => void>(
        (element: string) => (value: any) => {
            const configBestNr = config?.fields?.find((e) => e.id === "bt-13")
            if (configBestNr && element === "rechnungsdaten.bestellnummer") {
                if (value?.match(configBestNr.pattern)) {
                    EventBus.instance.emit("changeProperty", element, value)
                } else {
                    EventBus.instance.emit("renderView")
                }
            } else {
                EventBus.instance.emit("changeProperty", element, value)
            }
        },
        [config],
    )

    const value = () => {
        return invoiceTypeOptions.find((o) => o.value === rechnungsdaten.rechnungsart)
    }

    return (
        <div>
            <Components.Collapsible title={t("rechnung.rechnungsdaten.title")} collapsed={false}>
                <Components.FormGroup label={t("rechnung.rechnungsdaten.rechnungsart.label")}>
                    <Components.MultiSelect
                        placeholder={t("rechnung.rechnungsdaten.rechnungsart.placeholder")}
                        onChange={onChange("rechnungsdaten.rechnungsart")}
                        value={value()}
                        options={invoiceTypeOptions}
                    />
                </Components.FormGroup>
                <Components.FormGroup label={t("rechnung.rechnungsdaten.leitwegId.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungsdaten.leitwegId.placeholder")}
                        onChange={onChange("rechnungsdaten.leitwegId")}
                        value={rechnungsdaten.leitwegId}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungsdaten.bestellnummer.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungsdaten.bestellnummer.placeholder")}
                        onChange={onChange("rechnungsdaten.bestellnummer")}
                        value={rechnungsdaten.bestellnummer}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungsdaten.rechnungsnummer.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungsdaten.rechnungsnummer.placeholder")}
                        onChange={onChange("rechnungsdaten.rechnungsnummer")}
                        value={rechnungsdaten.rechnungsnummer}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungsdaten.rechnungsdatum.label")}>
                    <Components.DateEdit modelPath="rechnungsdaten.rechnungsdatum" value={rechnungsdaten.rechnungsdatum} />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungsdaten.faelligkeitsdatum.label")}>
                    <Components.DateEdit modelPath="rechnungsdaten.faelligkeitsdatum" value={rechnungsdaten.faelligkeitsdatum} />
                </Components.FormGroup>

                {
                    // BT-5
                    // Hier fehlt noch eine Komponente vom Typ waehrung
                }
                <Components.FormGroup label={t("rechnung.rechnungsdaten.waehrungRechnung.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungsdaten.waehrungRechnung.placeholder")}
                        onChange={onChange("rechnungsdaten.waehrungRechnung")}
                        value={rechnungsdaten.waehrungRechnung}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.lieferinformation.lieferdatum.label")}>
                    <Components.DateEdit modelPath="lieferinformation.lieferdatum" value={lieferinformation.lieferdatum} />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungsdaten.abrechnungszeitraumVon.label")}>
                    <Components.DateEdit modelPath="rechnungsdaten.abrechnungszeitraumVon" value={rechnungsdaten.abrechnungszeitraumVon} />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungsdaten.abrechnungszeitraumBis.label")}>
                    <Components.DateEdit modelPath="rechnungsdaten.abrechnungszeitraumBis" value={rechnungsdaten.abrechnungszeitraumBis} />
                </Components.FormGroup>

                {!FeatureService.isFeatureActive("DEMO") && (
                    <>
                        <RechnungstexteView />
                        <RechnungsdatenSonstigeView />
                    </>
                )}
            </Components.Collapsible>
        </div>
    )
}
